<dv-dialog-content>
  @if (!data.serial) {
    <div class="asset-find-update-dialog">
      <dv-alert-banner
        type="warning"
        contentText="{{
          'Asset.DeleteDialog.Info' | translate
        }}"></dv-alert-banner>
      <div>{{ 'Asset.DeleteDialog.ChoicesText' | translate }}</div>
      <dv-dynamic-form
        class="asset-find-update-dialog__form"
        [elements]="elements | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
    </div>
  } @else {
    <div class="asset-find-update-dialog">
      <dv-alert-banner
        type="warning"
        contentText="{{
          'Asset.UpdateFindDialog.Info' | translate
        }}"></dv-alert-banner>
      <div>
        {{
          'Asset.UpdateFindDialog.ChoicesText'
            | translate: { serial: data.serial }
        }}
      </div>
      <dv-dynamic-form
        class="asset-find-update-dialog__form"
        [elements]="elements | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
    </div>
  }

  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button footer-right color="danger" (click)="confirm()">
    {{ 'General.Confirm' | translate }}
  </dv-button>
</dv-dialog-content>
